const FULL_APPROVED  = 5
const BACKEND_UPLOAD_URL  = process.env.VUE_APP_BASE_URL || "https://demo.sfmagtech.com/estamp_payer_v0"
//const BACKEND_UPLOAD_URL  = process.env.VUE_APP_BASE_URL || "http://localhost:8001"
export default {
  FULL_APPROVED,
  BACKEND_UPLOAD_URL
}